import { useState } from 'react';

import { Box } from '@mui/system';

import { navigate } from '@redwoodjs/router';

import Loader from 'src/components/Loader/Loader';
import { NPIDataGrid } from 'src/components/NPIDataGrid/NPIDataGrid';
import { DEFAULT_BORDER } from 'src/constants';
import useMerchantServices, {
    MerchantServicesType,
} from 'src/hooks/useMerchantServices/useMerchantServices';
import { PageContent } from 'src/layouts/MainLayout/PageContent';
import ServicesTableColumnDef from 'src/pages/MerchantServicesPage/components/ServicesTableColumnDef';
import TabMenuList from 'src/pages/MerchantServicesPage/components/TabMenuList';
import TabMenuListItem from 'src/pages/MerchantServicesPage/components/TabMenuListItem';
import { Service } from 'types/graphql';

const MerchantServicesPage = () => {
    const [activeTab, setActiveTab] = useState<MerchantServicesType>('in progress');

    const handleView = ({ id }: { id: string }) => {
        if (activeTab === 'in progress') {
            const merchantId = merchantServices?.find((item: Service) => {
                return item.id === id;
            })?.merchantId;

            if (!merchantId) {
                return;
            }

            return navigate(`/merchant/${merchantId}/add-service`);
        }

        return navigate(`/service/view/${id}`);
    };

    const { loading, services: merchantServices } = useMerchantServices(activeTab);

    return (
        <PageContent heading="Services" subHeading="View and manage all merchant Service Orders">
            <Box
                flexGrow={1}
                sx={{
                    ...DEFAULT_BORDER,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <TabMenuList>
                    <TabMenuListItem
                        isActive={activeTab === 'in progress'}
                        label={'In Progress'}
                        onClick={() => {
                            return setActiveTab('in progress');
                        }}
                    />
                    <TabMenuListItem
                        isActive={activeTab === 'completed'}
                        label={'Completed'}
                        onClick={() => {
                            return setActiveTab('completed');
                        }}
                    />
                </TabMenuList>

                {loading && <Loader />}

                <NPIDataGrid
                    rows={merchantServices}
                    columns={ServicesTableColumnDef()}
                    getRowId={(row) => {
                        return row.id;
                    }}
                    handleView={({ id }) => {
                        handleView({ id });
                    }}
                    dataTestId={'merchant-services-page-table'}
                />
            </Box>
        </PageContent>
    );
};

export default MerchantServicesPage;
